import React, { Component } from 'react';
import { connect } from 'react-redux';
import NotComeOut from '../../../common/not-come-out/NotComeOut';
import Contributors from './list-tab/Contributors';
import MostPopular from './list-tab/MostPopular';
import MostRecent from './list-tab/MostRecent';
import ContributorInfo from './list-tab/Contributors/ChildTab/ContributorInfo';
import { REDUCER_NAME } from '../../reducer';

class ExpertView extends Component {
  getContributorsTab = expertId => {
    return (
      <div className="px-20">
        {expertId ? <ContributorInfo /> : <Contributors />}
      </div>
    );
  };

  render() {
    const {
      currentChildTab,
      contributorsData: {
        currentExpert: { expertId },
      },
    } = this.props;

    if (currentChildTab !== 1) {
      return <NotComeOut />;
    }

    return (
      <div className="expert-wrapper d-flex flex-fill flex-column">
        {currentChildTab === 3 ? (
          this.getContributorsTab(expertId)
        ) : (
          <div className="px-20 d-flex flex-fill flex-column">
            {currentChildTab === 1 && <MostRecent />}
            {currentChildTab === 2 && <MostPopular />}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    currentChildTab: state[REDUCER_NAME].currentChildTab,
    contributorsData: state[REDUCER_NAME].contributorsData,
  };
};

export default connect(mapStateToProps)(ExpertView);
